module.exports = __webpack_public_path__ + "static/media/no-book-img.39f1033b.jpg";